import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import classes from './PulsingAvatar.module.scss';

const PulsingAvatar = props => (
  <div className={classes.avatarContainer}>
    <div className={classes.pulseContainer}>
      <div className={`${classes.pulse} ${classes.pulseOuter}`} />
    </div>
    <div className={classes.pulseContainer}>
      <div className={`${classes.pulse} ${classes.pulseInner}`} />
    </div>
    <div className={classes.avatar}>
      <SVG src={props.icon} />
    </div>
  </div>
);


PulsingAvatar.propTypes = {
  icon: PT.string.isRequired
};

export default PulsingAvatar;
